const messages = {
    en: {
        delivery: {
            order: {
                title: 'Order management',
                subtitle: 'View, search, create, edit and delete Order',
                creating: 'Creating Order',
                editing: 'Editing Order',
                deleting: 'Deleting Order',
                showing: 'Showing Order',
                labels: {
                    order: 'order',
                    type: 'Type',
                    name: 'Name',
                    phone: 'Phone',
                    email: 'Email',
                    observations: 'Observations',
                    address: 'Address',
                    addressOrName: 'Address or name',
                    state: 'State',
                    identifier: 'Identifier',
                    paymentMethod: 'Payment method',
                    totalAmount: 'Total amount'
                },

            },
        }
    },
    es: {
        delivery: {
            order: {
                title: 'Administración de Orden',
                subtitle: 'Ver, buscar, crear, editar, y borrar Orden',
                creating: 'Creando Orden',
                editing: 'Modificando Orden',
                deleting: 'Eliminando Orden',
                showing: 'Detalles de Orden',
                labels: {
                    order: 'Orden',
                    type: 'Tipo',
                    name: 'Nombre',
                    phone: 'Teléfono',
                    email: 'Email',
                    observations: 'Observaciones',
                    address: 'Dirección',
                    addressOrName: 'Dirección / Nombre',
                    state: 'Estado',
                    identifier: 'Identificador',
                    paymentMethod: 'Método de pago',
                    totalAmount: 'Total'
                },

            },
        }
    },
    pt: {
        delivery: {
            order: {
                title: 'Administração de Order',
                subtitle: 'Ver, buscar, criar, editar e usar Order',
                creating: 'Criando Order',
                editing: 'Edição Order',
                deleting: 'Apagando Order',
                showing: 'Detalhes do Order',
                labels: {
                    order: 'Order',
                    type: 'Tipo',
                    name: 'Nome',
                    phone: 'Telefono',
                    email: 'Email',
                    observations: 'Observações',
                    address: 'Dirección',
                    addressOrName: 'Dirección / Nome',
                    state: 'Estado',
                    identifier: 'Identificador',
                    paymentMethod: 'Método de pago',
                    totalAmount: 'Total amount'
                },

            },
        }
    }

}


export default messages
